// @flow
import * as React from "react";
import Media from "react-media";
import { type RouterHistory } from "react-router-dom";
import styled from "styled-components";
import { gaReducer } from "../GA";
import MobilePopup from "../TradeMobile/Popup";

import SocialItems from "./Items";
import Social from "./Social";

const ContentContainer = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding-top: 12px;
  background-color: ${({ theme }) => theme.main};
`;

type Props = {
  className?: string,
  history: RouterHistory
};

const SocialPopup = ({ className, ...props }: Props) => (
  <Media
    query="(max-width: 959px)"
    render={() => (
      <MobilePopup
        title={null}
        type="tournaments"
        onClick={() => {
          gaReducer("CLOSE_SOCIAL_TRADING");
          return props.history.replace("/trade");
        }}
        className={className}
      >
        <ContentContainer>
          <Social>
            <SocialItems onItemClick={() => props.history.replace("/trade")} />
          </Social>
        </ContentContainer>
      </MobilePopup>
    )}
  />
);

export default SocialPopup;



// WEBPACK FOOTER //
// ./src/components/SocialTrading/Mobile.js